// extracted by mini-css-extract-plugin
export default {"box":"TopRowBox_box__AD6LA"};